import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // 最大值标记线
  {
    name: 'MARK_LINE_MAX',
    value: 'Max'
  },
  // 最小值标记线
  {
    name: 'MARK_LINE_MIN',
    value: 'Min'
  },
  // 平均值标记线
  {
    name: 'MARK_LINE_AVG',
    value: 'Avg'
  },
  // 目标值标记线
  {
    name: 'MARK_LINE_TARGET',
    value: 'Target'
  }
]

export default consts